"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var clsPrefix = 'kui-new-table';

var TableBody = function TableBody(_ref) {
  var _ref$dataSource = _ref.dataSource,
      dataSource = _ref$dataSource === void 0 ? [] : _ref$dataSource,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$onRowClick = _ref.onRowClick,
      onRowClick = _ref$onRowClick === void 0 ? function () {
    return null;
  } : _ref$onRowClick,
      stripe = _ref.stripe;
  return /*#__PURE__*/React.createElement("tbody", {
    className: "".concat(clsPrefix, "__body")
  }, dataSource.length ? dataSource.map(function (data, index) {
    return /*#__PURE__*/React.createElement("tr", {
      className: (0, _classnames["default"])("".concat(clsPrefix, "__body-row"), _defineProperty({}, "".concat(clsPrefix, "__body-row--stripped"), stripe)),
      onClick: function onClick() {
        onRowClick(data);
      }
    }, columns.map(function (item) {
      if (item.render) {
        var component = item.dataIndex ? item.render({
          data: data,
          item: data[item.dataIndex],
          index: index
        }) : item.render({
          data: data,
          index: index
        }); // @ts-ignore

        var _ref2 = component || {},
            children = _ref2.children,
            props = _ref2.props;

        if (children !== undefined) {
          if ((props === null || props === void 0 ? void 0 : props.colSpan) === 0) {
            return null;
          }

          return /*#__PURE__*/React.createElement("td", _extends({
            style: _objectSpread(_objectSpread({
              textAlign: item.align
            }, style), {}, {
              width: item.width
            }),
            className: "".concat(clsPrefix, "__body-cell"),
            key: item.key
          }, props || {}), children);
        } else {
          return /*#__PURE__*/React.createElement("td", {
            style: _objectSpread(_objectSpread({
              textAlign: item.align
            }, style), {}, {
              width: item.width
            }),
            className: "".concat(clsPrefix, "__body-cell"),
            key: item.key
          }, component);
        }
      }

      return /*#__PURE__*/React.createElement("td", {
        style: _objectSpread(_objectSpread({
          textAlign: item.align
        }, style), {}, {
          width: item.width
        }),
        className: "".concat(clsPrefix, "__body-cell"),
        key: item.key
      }, data[item['dataIndex']]);
    }));
  }) : null);
};

var _default = TableBody;
exports["default"] = _default;